import axios from "axios";
const { BASE_URL } = require("../utils/urls");
//const BASE_URL = "https://panaccoapi-453601304730.asia-south1.run.app"; // Adjust the base URL as needed
//const BASE_URL = "http://localhost:8080";
export const getInventorySummary = async (orgId: string) => {
  try {
    const response = await axios.get(`${BASE_URL}/Inventory/item/inventorySummary?orgId=${orgId}`);
    return response.data; // Return API response data
  } catch (error) {
    console.error("Error fetching inventory summary:", error);
    return null; // Handle errors gracefully
  }
};
export const getTopCustomers = async (orgId: string) => {
  try {
    if (!orgId) throw new Error("Organization ID is required");

    const response = await axios.get(`${BASE_URL}/api/invoice/getTopCustomers?orgId=${orgId}`);
    const customers = response.data.customers;

    if (!customers || customers.length === 0) {
      throw new Error("No customer data found");
    }
    return customers; // Return customer data to be used in components
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "Failed to fetch top customers");
  }
};
export const getSalesPerformance = async (orgId: string, timeframe: string) => {
  try {
  //  const response = await axios.get(`${BASE_URL}/api/invoice/getSalesPerformance`,
  const response = await axios.get(`${BASE_URL}/api/invoice/getSalesPerformance`,
       {
      params: { orgId, timeframe }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales performance:", error);
    throw error;
  }
};
export const getMonthlySoldQty = async (orgId: string) => {
  try {
    if (!orgId) {
      console.error("Missing orgId");
      return { success: false, message: "Missing orgId" };
    }
    const response = await axios.get(`${BASE_URL}/api/invoice/getMonthlySoldQty?orgId=${orgId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching monthly sold quantity:", error);
    return { success: false, message: "Failed to fetch data" };
  }
};
// export const getStockByCategory = async (orgId: string) => {
//   try {
//     const response = await axios.get(`${BASE_URL}/Inventory/item/stockByCategory?orgId=${orgId}`);
//     if (response.data.success) {
//       return response.data.categoryStock; // Return the categoryStock data
//     } else {
//       throw new Error(response.data.message);
//     }
//   } catch (error) {
//     console.error("Error fetching stock by category:", error);
//     throw error;
//   }
// };
export const getStockByCategory = async (
  orgId: string,
  stockFilter?: string
) => {
  try {
    let url = `${BASE_URL}/Inventory/item/stockByCategory?orgId=${orgId}&stockFilter=${stockFilter}`;

    const response = await axios.get(url);

    if (response.data.success) {
      return response.data.categoryStock; // Return the categoryStock data
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching stock by category:", error);
    throw error;
  }
};
export const getDashboardInvoiceStats = async (orgId: string) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/invoice/getDashboardInvoiceStats`, {
      params: { orgId },
    });
    return response.data; // { success, totalInvoices, totalSales }
  } catch (error) {
    console.error("Error fetching dashboard invoice stats:", error);
    return null;
  }
};

export const getUserTypeCounts = async (orgId: string, userTypes: string[]) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/customers/getUserTypeCounts`, {
      params: { orgId, userTypes: userTypes.join(",") },
    });
    return response.data; // { success, counts: { customer: N, vendor: M, ... } }
  } catch (error) {
    console.error("Error fetching user type counts:", error);
    return null;
  }
};
